import { SITE_IS_JBDA } from '@/config/site.config'
import { getGlossaries } from '@/lib/glossary/glossary-services'
import { I18nValue, LangCode } from '../i18n/lang-context'

export type GlossaryEntry = {
  name: I18nValue
  shortDesc: I18nValue
  longDesc: I18nValue
}
export type Glossary = { [key: string]: GlossaryEntry }

let GLOSSARY: { [lang: string]: Glossary} = {}

async function refreshGlossary(lang: LangCode) {
  if(SITE_IS_JBDA)
    return {}
  return await getGlossaries(lang).then((results: any) => {
    const glossary: Glossary = {}
    for(let result of results) {
      glossary[result.key] = {name: {}, shortDesc: {}, longDesc: {}}
      glossary[result.key].name[lang] = result.name
      glossary[result.key].shortDesc[lang] = result.shortDesc
      glossary[result.key].longDesc[lang] = result.longDesc
    }
    GLOSSARY[lang] = glossary
    return glossary as Glossary
  })
}
export async function getGlossary(langCode: LangCode, glossary?: Glossary) {
  if(glossary) {
    return glossary
  }
  if(!GLOSSARY[langCode]) {
    return await refreshGlossary(langCode).then((glossary: Glossary) => glossary)
  }
  return GLOSSARY[langCode]
}
export async function getGlossaryEntry(langCode: LangCode, key: string, glossary: Glossary) {
  return await getGlossary(langCode, glossary).then((_glossary: Glossary) => {
    const glossaryEntry = readGlossaryEntry(key, _glossary)
    if(!glossaryEntry) {
      return Promise.resolve(refreshGlossary(langCode).then((glossary: Glossary) => readGlossaryEntry(key, glossary)))
    }
    return glossaryEntry
  })
}
export function readGlossaryEntry(key: string, glossary: Glossary) {
  return glossary && glossary[key]
}
